/**
 * @generated SignedSource<<f4cf9e76a0121fe41948aab4edff6ef6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BrainSearchMessageExternalSourceEntity = "image" | "video" | "website" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type BrainSearchMessageExternalSourceFragment$data = {
  readonly entity: BrainSearchMessageExternalSourceEntity;
  readonly id: string;
  readonly owner: string;
  readonly score: number;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "BrainSearchMessageExternalSourceFragment";
};
export type BrainSearchMessageExternalSourceFragment$key = {
  readonly " $data"?: BrainSearchMessageExternalSourceFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BrainSearchMessageExternalSourceFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BrainSearchMessageExternalSourceFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "owner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "score",
      "storageKey": null
    }
  ],
  "type": "BrainSearchMessageExternalSource",
  "abstractKey": null
};

(node as any).hash = "0005d05b6a0f9a062f25e30d5e3faf64";

export default node;
